'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _templateData = require('redux/modules/templateData');

var templateActions = _interopRequireWildcard(_templateData);

var _semanticUiReact = require('semantic-ui-react');

var _constants = require('../../constants');

require('./SectionEditor.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./SectionEditor.scss');

var SectionEditor = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    info_block: state.templateData.info_block,
    show_section_editor: state.templateData.show_section_editor,
    base_url: state.company.base_url
  };
}, {
  showSectionEditor: templateActions.showSectionEditor,
  addNewInfoBlock: templateActions.addNewSection,
  pushState: _reactRouterRedux.push
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(SectionEditor, _Component);

  function SectionEditor(props) {
    (0, _classCallCheck3.default)(this, SectionEditor);

    // const {  } = this.props;
    var _this = (0, _possibleConstructorReturn3.default)(this, (SectionEditor.__proto__ || (0, _getPrototypeOf2.default)(SectionEditor)).call(this, props));

    _this.handleClose = function () {
      _this.props.showSectionEditor(false);
    };

    _this.addSection = function (_ref) {
      var value = _ref.value;


      var new_data = {
        id: Math.floor(Math.random() * 100000 + 1),
        group: 1,
        type: value,
        company: '',
        heading: value,
        designation: '',
        location: '',
        short_title: '',
        title: '',
        date_from: null,
        date_to: null,
        description: '{"entityMap":{},"blocks":[{"key":"d8i6e","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}]}',
        chart_data: '',
        chart_type: ''
      };

      _this.props.addNewInfoBlock(new_data);
    };

    _this.state = {
      newSection: '',
      newValue: '',
      sectionDataArray: []
    };

    return _this;
  }

  (0, _createClass3.default)(SectionEditor, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps != this.props) {
        var info_block = nextProps.info_block;
        var filtered = _constants.SECTION_TYPES.filter(function (item) {
          if (!info_block[item.value]) {
            return true;
          } else {
            if (!info_block[item.value].length) {
              return true;
            }
          }
        });
        this.setState({ sectionDataArray: filtered });
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var info_block = this.props.info_block;
      var filtered = _constants.SECTION_TYPES.filter(function (item) {
        if (!info_block[item.value]) {
          return true;
        } else {
          if (!info_block[item.value].length) {
            return true;
          }
        }
      });
      this.setState({ sectionDataArray: filtered });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // const { chartX, chartY, data_parent, data_id, data_typ } = this.props;
      var _state = this.state,
          newSection = _state.newSection,
          newValue = _state.newValue,
          sectionDataArray = _state.sectionDataArray;


      return _react2.default.createElement(
        _semanticUiReact.Form,
        { size: 'small', style: { borderRadius: '5px' } },
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { style: { padding: '15px' }, clearing: true, raised: false },
          _react2.default.createElement(
            _semanticUiReact.Header,
            { floated: 'left' },
            'Choose Sections to Add:'
          ),
          _react2.default.createElement(
            _semanticUiReact.Header,
            { floated: 'right' },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', onClick: this.handleClose })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', flexWrap: 'wrap', padding: '30px' } },
          sectionDataArray && sectionDataArray.map(function (sectionObject, index) {
            return _react2.default.createElement(_semanticUiReact.Form.Button, {
              key: sectionObject.value + '-1',
              content: sectionObject.text,
              onClick: function onClick(e) {
                return _this2.addSection(sectionObject);
              }
            });
          })
        )
      );
    }
  }]);
  return SectionEditor;
}(_react.Component)) || _class);
exports.default = SectionEditor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionEditor/SectionEditor.js
// module id = 1745
// module chunks = 0